import { render, staticRenderFns } from "./ExpertsQuestion.vue?vue&type=template&id=9869f7f4&scoped=true&"
import script from "./ExpertsQuestion.vue?vue&type=script&lang=js&"
export * from "./ExpertsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ExpertsQuestion.vue?vue&type=style&index=0&id=9869f7f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9869f7f4",
  null
  
)

export default component.exports